import React from "react";
import {
  Identifiable,
  Project,
  Document,
  Id,
  Folder,
  project as mockProject,
  folder as mockFolder,
} from "@planzone/dto";

type SelectDocumentsContextType = {
  loading: boolean;
  project: Identifiable<Project>;
  selection: Array<Identifiable<Document>>;
  currentFolderId: string;
  currentFolderPath: Identifiable<Folder>[];
  currentFolder: Identifiable<Folder>;
  rootFolder: Identifiable<Folder>;
  setCurrentFolder(folderUuid: Id): void;
  removeFromSelection(documentUuid: Id): void;
  addToSelection(document: Identifiable<Document>): void;
  resetSelection(): void;
};

const SelectDocumentsContext = React.createContext<SelectDocumentsContextType>({
  loading: true,
  project: mockProject,
  selection: [],
  currentFolderId: "",
  currentFolderPath: [],
  currentFolder: { uuid: "", ...mockFolder },
  rootFolder: { uuid: "", ...mockFolder },
  setCurrentFolder(folderUuid: Id) {},
  removeFromSelection(documentUuid: Id) {},
  addToSelection(document: Identifiable<Document>) {},
  resetSelection() {},
});

function getSelectedFolderPath(
  selectedFolder: Identifiable<Folder>,
  folder: Identifiable<Folder>,
): {
  path: Identifiable<Folder>[];
  hasMatched: boolean;
} {
  const res: { path: Identifiable<Folder>[]; hasMatched: boolean } =
    folder.children
      .filter(({ type }) => type === "folder")
      .reduce<{
        path: Identifiable<Folder>[];
        hasMatched: boolean;
      }>(
        (p, child) => {
          const c = child as Identifiable<Folder>;
          const { path, hasMatched } = getSelectedFolderPath(selectedFolder, c);

          return hasMatched ? { hasMatched, path } : p;
        },
        { hasMatched: false, path: [] },
      );
  const isMatching = folder.uuid === selectedFolder.uuid;

  return res.hasMatched || isMatching
    ? { hasMatched: res.hasMatched || isMatching, path: [folder, ...res.path] }
    : res;
}

function useSelectDocumentsContext() {
  return React.useContext(SelectDocumentsContext);
}

export {
  SelectDocumentsContext,
  useSelectDocumentsContext,
  getSelectedFolderPath,
};
